<script>
	import { formatPhone, formatAddress } from "../../../../../SharedSvelte/Common.svelte";
	import { Card, CardBody, CardHeader } from "@sveltestrap/sveltestrap";           

	let {		
		residentialAddress1 = "",
		residentialAddress2 = "",
		residentialCity = "",
		residentialState = "",
		residentialZip = "",
		mailingAddress1 = "",
		mailingAddress2 = "",
		mailingCity = "",
		mailingState = "",
		mailingZip = "",
		homePhone = "",
		cellPhone = "",
		email = "",
		contactMethod,
		documentDeliveryMethod,
        isPHIRestricted,
        isUserSubscriber
	} = $props();

	let formattedCellPhone = cellPhone ? formatPhone(cellPhone) : "None";
    let formattedHomePhone = homePhone ? formatPhone(homePhone) : "None";
    let formattedResidentialAddress = residentialAddress1 ? formatAddress(
        residentialAddress1, 
        residentialAddress2, 
        residentialCity, 
        residentialState, 
        residentialZip, "") : "None"; 
    let formattedMailingAddress = mailingAddress1 ? formatAddress(
        mailingAddress1, 
        mailingAddress2, 
        mailingCity, 
        mailingState, 
        mailingZip, "") : "None";      
</script>

<div>
<Card class="mb-3">            
    <CardBody>                     
        <ul class="list-group list-group-flush">
            <li class="list-group-item">
                <div class="row">
                    <div class="col-md-4 col-sm-4 col-xs-12">Residential Address:</div>
                    <div class="col-md-6 col-sm-6 col-xs-12 ms-2"><strong>{@html formattedResidentialAddress}</strong></div>
                </div>                                                              
            </li>
            <li class="list-group-item mt-1">
                <div class="row">
                    <div class="col-md-4 col-sm-4 col-xs-12">Mailing Address:</div>
                    <div class="col-md-6 col-sm-6 col-xs-12 ms-2"><strong>{@html formattedMailingAddress}</strong></div>
                </div> 
            </li>
            <li class="list-group-item mt-1">
                <div class="row">
                    <div class="col-md-4 col-sm-4 col-xs-12">Cell Phone:</div>
                        <div class="col-md-6 col-sm-6 col-xs-12 ms-2"><strong>{formattedCellPhone}</strong></div>
                </div>
            </li>
            <li class="list-group-item mt-1">
                <div class="row">
                    <div class="col-md-4 col-sm-4 col-xs-12">Home Phone:</div>
                    <div class="col-md-6 col-sm-6 col-xs-12 ms-2"><strong>{formattedHomePhone}</strong></div>
                </div>
            </li>                       
            <li class="list-group-item mt-1">
                <div class="row">
                    <div class="col-md-4 col-sm-4 col-xs-4">Email:</div>
                    <div class="col-md-6 col-sm-6 col-xs-12 ms-2"><strong>{email}</strong></div>
                </div>
            </li>                                                                                                            
            <li class="list-group-item mt-1">
                <div class="row">
                    <div class="col-md-4 col-sm-4 col-xs-12">Communication Preferences:</div>
                    <div class="col-md-6 col-sm-6 col-xs-12 ms-2">Contact Method: <strong>{contactMethod}</strong></div>                           
                </div>
                <div class="row">
                    <div class="col-md-4 col-sm-4 col-xs-12">&nbsp;</div>
                    <div class="col-md-6 col-sm-6 col-xs-12 ms-2">Document Delivery: <strong>{documentDeliveryMethod}</strong></div>
                </div>
            </li>
            {#if !isUserSubscriber}
                <li class="list-group-item mt-1">
                    <div class="row">
                        <div class="col-md-4 col-sm-4 col-xs-12">Personal Health Information Privacy:</div>
                            <div class="col-md-6 col-sm-6 col-xs-12 ms-2">
                            {#if isPHIRestricted}
                                 <strong>Do not allow the subscriber to view my information</strong>
                            {:else}
                                <strong>Allow the subscriber to view my information</strong>
                            {/if}                           
                        </div>
                    </div> 
                </li>                       
            {/if}                         
        </ul>                    
    </CardBody>
</Card>
</div>